import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  role: "footer",
  class: "footer"
}
const _hoisted_2 = { class: "footer__top" }
const _hoisted_3 = { class: "footer__wrapper" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "footer__check" }
const _hoisted_6 = { class: "footer__form" }
const _hoisted_7 = { class: "footer__form-grid" }
const _hoisted_8 = { class: "footer__button" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "footer__bottom" }
const _hoisted_12 = { class: "footer__block footer__block--wrapper" }
const _hoisted_13 = { class: "footer__block" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "footer__block-gadgets visible--flex--middle" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "footer__block-gadgets visible--grid--narrow" }
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "footer__part visible--flex--middle hidden-part" }
const _hoisted_29 = { class: "footer__block footer__block--second" }
const _hoisted_30 = { class: "footer__part hidden--flex--middle hidden-part" }
const _hoisted_31 = { class: "footer__part hidden--flex--narrow" }
const _hoisted_32 = { class: "footer__block footer__block--mobile" }
const _hoisted_33 = { class: "footer__part footer__part--social" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Link = _resolveComponent("Link")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ButtonAction = _resolveComponent("ButtonAction")!
  const _component_Wrapper = _resolveComponent("Wrapper")!
  const _component_ButtonSimple = _resolveComponent("ButtonSimple")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_Wrapper, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[17] || (_cache[17] = _createElementVNode("div", null, [
              _createElementVNode("div", { class: "footer__image" })
            ], -1)),
            (!(_ctx.isSuccess || _ctx.isError))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "footer__title" }, " Закажите бесплатную демонстрацию продукта ", -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "footer__subtitle" }, " Наш менеджер свяжется с Вами для обсуждения деталей ", -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_Checkbox, {
                      text: "Я предоставляю ",
                      text2: " и соглашаюсь с условиями ",
                      modelValue: _ctx.isCheckFooter,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCheckFooter) = $event))
                    }, {
                      link: _withCtx(() => [
                        _createVNode(_component_Link, {
                          text: "Согласие на обработку персональных данных",
                          link: `./Consent_of_Personal_Data_processing.pdf`
                        })
                      ]),
                      link2: _withCtx(() => [
                        _createVNode(_component_Link, {
                          text: "Политики в отношении обработки персональных данных",
                          link: `./DRSO_Approved_Licensing_Policy.pdf`
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_Input, {
                          modelValue: _ctx.nickname,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nickname) = $event)),
                          skin: "map",
                          placeholder: "Как к Вам обращаться"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_Input, {
                          modelValue: _ctx.phone,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
                          skin: "map",
                          placeholder: "Номер телефона",
                          "is-phone": ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_Button, {
                        class: "hidden--inline-block--narrow",
                        size: "helike",
                        "is-disabled": !_ctx.isCheckFooter,
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.postForm()), ["prevent"]))
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("Отправить")
                        ])),
                        _: 1
                      }, 8, ["is-disabled"]),
                      _createVNode(_component_Button, {
                        class: "hidden--inline-block--not-narrow",
                        size: "helike",
                        "is-wide": "",
                        "is-disabled": !_ctx.isCheckFooter,
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.postForm()), ["prevent"]))
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("Отправить")
                        ])),
                        _: 1
                      }, 8, ["is-disabled"])
                    ])
                  ])
                ]))
              : (_ctx.isError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_Icon, {
                      class: "footer__form-icon",
                      name: "error"
                    }),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "footer__form-title" }, "Ошибка отправки", -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "footer__form-subtitle" }, " Что-то пошло не так. Пожалуйста, повторите попытку позже ", -1)),
                    _createVNode(_component_ButtonAction, {
                      color: "rocky",
                      class: "footer__form-action",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.nullForm()), ["prevent"]))
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("Отправить")
                      ])),
                      _: 1
                    })
                  ]))
                : (_ctx.isSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_Icon, {
                        class: "footer__form-icon",
                        name: "success"
                      }),
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "footer__form-title" }, "Заявка отправлена", -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "footer__form-subtitle" }, " Наш менеджер свяжется с вами, чтобы обсудить детали и договориться об удобном времени ", -1)),
                      _createVNode(_component_ButtonAction, {
                        color: "rocky",
                        class: "footer__form-action",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.nullForm()), ["prevent"]))
                      }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode("Хорошо")
                        ])),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createVNode(_component_Wrapper, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (_ctx.theme === _ctx.Themes.default)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "hidden--block--gadgets",
                    src: require(`@/assets/svg/logo_main.svg`)
                  }, null, 8, _hoisted_14))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "hidden--block--gadgets",
                    src: require(`@/assets/svg/logo_main--white.svg`)
                  }, null, 8, _hoisted_15)),
              (_ctx.theme === _ctx.Themes.default)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    class: "hidden--block--gadgets",
                    src: require(`@/assets/svg/logo_RIR.svg`)
                  }, null, 8, _hoisted_16))
                : (_openBlock(), _createElementBlock("img", {
                    key: 3,
                    class: "hidden--block--gadgets",
                    src: require(`@/assets/svg/logo_RIR--white.svg`)
                  }, null, 8, _hoisted_17)),
              _createElementVNode("div", _hoisted_18, [
                (_ctx.theme === _ctx.Themes.default)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: require(`@/assets/svg/logo_main.svg`)
                    }, null, 8, _hoisted_19))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: require(`@/assets/svg/logo_main--white.svg`)
                    }, null, 8, _hoisted_20)),
                (_ctx.theme === _ctx.Themes.default)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      src: require(`@/assets/svg/logo_RIR.svg`)
                    }, null, 8, _hoisted_21))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 3,
                      src: require(`@/assets/svg/logo_RIR--white.svg`)
                    }, null, 8, _hoisted_22))
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", null, [
                  (_ctx.theme === _ctx.Themes.default)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: require(`@/assets/svg/logo_main.svg`)
                      }, null, 8, _hoisted_24))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require(`@/assets/svg/logo_main--white.svg`)
                      }, null, 8, _hoisted_25))
                ]),
                _createElementVNode("div", null, [
                  (_ctx.theme === _ctx.Themes.default)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: require(`@/assets/svg/logo_RIR.svg`)
                      }, null, 8, _hoisted_26))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require(`@/assets/svg/logo_RIR--white.svg`)
                      }, null, 8, _hoisted_27))
                ])
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "hidden--block--gadgets" }, [
                _createElementVNode("span", { style: {"white-space":"nowrap"} }, "АО «Росатом инфраструктурные решения»"),
                _createElementVNode("br"),
                _createElementVNode("span", { style: {"white-space":"nowrap"} }, "2025 • Все права защищены")
              ], -1)),
              _createElementVNode("div", _hoisted_28, [
                _cache[18] || (_cache[18] = _createElementVNode("div", null, "Тема", -1)),
                _createVNode(_component_ButtonSimple, {
                  skin: "secondary",
                  onClick: _withModifiers(_ctx.toggleTheme, ["prevent"]),
                  "is-rounded": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, { name: "ecology" })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[20] || (_cache[20] = _createElementVNode("div", null, "Тема", -1)),
                _createVNode(_component_ButtonSimple, {
                  skin: "secondary",
                  onClick: _withModifiers(_ctx.toggleTheme, ["prevent"]),
                  "is-rounded": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, { name: "ecology" })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "hidden--block--gadgets visible--inline-block--middle" }, [
                _createElementVNode("span", { style: {"white-space":"nowrap"} }, "АО «Росатом инфраструктурные решения»"),
                _createElementVNode("br"),
                _createElementVNode("span", { style: {"white-space":"nowrap"} }, "2025 • Все права защищены")
              ], -1)),
              _createElementVNode("div", _hoisted_31, [
                _cache[21] || (_cache[21] = _createElementVNode("div", null, "Поделиться", -1)),
                _createVNode(_component_ButtonSimple, {
                  skin: "secondary",
                  color: "amelie",
                  background: "vkontakte",
                  "is-rounded": "",
                  link: "https://vk.com/share.php?url=https%3A%2F%2Frso.rosatom.city&title=%D0%A6%D0%B8%D1%84%D1%80%D0%BE%D0%B2%D0%BE%D0%B5%20%D1%80%D0%B5%D1%81%D1%83%D1%80%D1%81%D0%BE%D1%81%D0%BD%D0%B0%D0%B1%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, { name: "vkontakte_16" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ButtonSimple, {
                  skin: "secondary",
                  color: "amelie",
                  background: "odnoklassniki",
                  "is-rounded": "",
                  link: "https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=https%3A%2F%2Frso.rosatom.city"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, { name: "odnoklassniki_16" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ButtonSimple, {
                  skin: "secondary",
                  color: "amelie",
                  background: "telegram",
                  "is-rounded": "",
                  link: "https://t.me/share/url?url=https%3A%2F%2Frso.rosatom.city&text=%D0%A6%D0%B8%D1%84%D1%80%D0%BE%D0%B2%D0%BE%D0%B5%20%D1%80%D0%B5%D1%81%D1%83%D1%80%D1%81%D0%BE%D1%81%D0%BD%D0%B0%D0%B1%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, { name: "telegram_16" })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[23] || (_cache[23] = _createElementVNode("div", null, "Поделиться", -1)),
                _createVNode(_component_ButtonSimple, {
                  skin: "secondary",
                  color: "amelie",
                  background: "vkontakte",
                  "is-rounded": "",
                  link: "https://vk.com/share.php?url=https%3A%2F%2Frso.rosatom.city&title=%D0%A6%D0%B8%D1%84%D1%80%D0%BE%D0%B2%D0%BE%D0%B5%20%D1%80%D0%B5%D1%81%D1%83%D1%80%D1%81%D0%BE%D1%81%D0%BD%D0%B0%D0%B1%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, { name: "vkontakte_16" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ButtonSimple, {
                  skin: "secondary",
                  color: "amelie",
                  background: "odnoklassniki",
                  "is-rounded": "",
                  link: "https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=https%3A%2F%2Frso.rosatom.city"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, { name: "odnoklassniki_16" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ButtonSimple, {
                  skin: "secondary",
                  color: "amelie",
                  background: "telegram",
                  "is-rounded": "",
                  link: "https://t.me/share/url?url=https%3A%2F%2Frso.rosatom.city&text=%D0%A6%D0%B8%D1%84%D1%80%D0%BE%D0%B2%D0%BE%D0%B5%20%D1%80%D0%B5%D1%81%D1%83%D1%80%D1%81%D0%BE%D1%81%D0%BD%D0%B0%D0%B1%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, { name: "telegram_16" })
                  ]),
                  _: 1
                })
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "visible--block--narrow" }, [
                _createElementVNode("span", null, "АО «Росатом инфраструктурные решения»"),
                _createElementVNode("br"),
                _createElementVNode("span", null, "2025 • Все права защищены")
              ], -1))
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}